module.exports = [{"value":"kudrat"}]


//////////////////
// WEBPACK FOOTER
// ./src/Controls/Select/DataHqCompany.json
// module id = 291
// module chunks = 21